import * as React from 'react'

import { STATUS_TONE_DOT_CLASS } from '#/lib/status-styles'
import type { StatusTone } from '#/lib/status-styles'
import { cn } from '#/lib/utils'

/**
 * A 6px status dot. Give it a brand `tone` (DESIGN.md §5); without one it takes
 * the current text colour. Always set it beside a word — the dot only echoes
 * the meaning, it never carries it alone.
 */
function StatusDot({
  className,
  tone,
  ...props
}: React.ComponentProps<'span'> & { tone?: StatusTone }) {
  return (
    <span
      aria-hidden
      data-slot="status-dot"
      data-tone={tone}
      className={cn(
        'size-1.5 shrink-0 rounded-full',
        tone ? STATUS_TONE_DOT_CLASS[tone] : 'bg-current',
        className,
      )}
      {...props}
    />
  )
}

export { StatusDot }
